export const GET_REPORTS_DATA ='GET_REPORTS_DATA';
export const GET_TREND_REPORTS_DATA ='GET_TREND_REPORTS_DATA';
export const RESET_REPORT_DATA ='RESET_REPORT_DATA';